<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="form-container">
    <form [formGroup]="loginForm" class="form">
      <app-input 
        [label]="'labels.email' | translate"
        [placeholder]="'placeholders.email' | translate"
        [formControl]="emailControl"
        type="email"
      ></app-input>
      
      <app-input 
        [label]="'labels.password' | translate"
        [placeholder]="'placeholders.password' | translate"
        [formControl]="passwordControl"
        type="password"
      ></app-input>
    </form>

    <app-button 
      [buttonLabel]="'buttons.signin' | translate"
      [buttonType]="BUTTON_TYPES.REGULAR"
      [buttonDisabled]="false"
      (click)="loginWithEmail()">
    </app-button>
  </div>

  <div class="divider"></div>

  <p>{{'login.account' | translate}}</p>
  <p class="link" (click)="register()">{{'login.register' | translate}}</p>

  <app-google-button (click)="loginWithGoogle()"></app-google-button>

  <div class="divider"></div>

  <p class="link" (click)="forgotPassword()">{{'login.forgot_password' | translate}}</p>

  <div class="terms-policies-container">
    <div (click)="view('terms')">{{'login.terms' | translate}}</div>
    <div (click)="view('policies')">{{'login.policies' | translate}}</div>    
  </div>

  <div class="about-container">
    <div (click)="view('about')">{{'login.about' | translate}}</div>
  </div>

  <div class="version">
    <span>{{getVersion()}}</span>
  </div>

  <app-languages-selector></app-languages-selector>

</div>
